import axios from "axios";
import "../utils/axios.interceptor";
import { urlCoreBack } from "../../project/configs/config";
const epName = "v1/persona-juridica/";
const nameItemsText = "Personas Jurídicas";
const nameItemText = "Persona Jurídica";
const itemGender = "F";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const getPersonaJuridicaByCuit = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener la Persona Jurídica";

  if (params) {

    if (params.condicionFrenteIva) {
      _params.id_condicion_frente_iva = params.condicionFrenteIva;
    }

    if (params.numeroCuitCuil) {
      _params.numero_cuit = params.numeroCuitCuil;
    }
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epName}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.exist = true;
        return response;
      } else {
        // si hay algun error controlado
        if (response.data.code === "err-persona-juridica-cuit-not-exist") {
          // si el error es de cliente no existe
          response.ok = true;
          response.exist = false;
          return response;
        }
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getPersonasJuridicas = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener Personas Jurídicas";

  if (params) {
    if (params.razonSocial) {
      _params.razon_social = params.razonSocial;
    }

    if (params.numeroCuit) {
      _params.numero_cuit = params.numeroCuit;
    }

    if (params.rows) {
      _params.rows = params.rows;
    }

    if (params.first) {
      _params.first = params.first;
    }
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epName}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const savePersonaJuridica = async (actionCrud, item) => {
  let _errorMessage = `No fue posible guardar ${elLa} ${nameItemText}`;

  try {
    let response = {};
    if (actionCrud === "new") {
      response = await axios({
        method: "POST",
        url: `${urlCoreBack}${epName}`,
        data: item,
      });
    } else if (actionCrud === "update") {
      response = await axios({
        method: "PUT",
        url: `${urlCoreBack}${epName}`,
        data: item,
      });
    } else if (actionCrud === "disable" || actionCrud === "enable") {
      response = await axios({
        method: "DELETE",
        url: `${urlCoreBack}${epName}`,
        params: {
          id: item.id,
          action: actionCrud,
        },
      });
    }

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText =
          `${nameItemText}` +
          (actionCrud === "disable"
            ? itemGender === "M"
              ? " deshabilitado"
              : " deshabilitada"
            : actionCrud === "enable"
              ? itemGender === "M"
                ? " habilitado"
                : " habilitada"
              : itemGender === "M"
                ? " guardado"
                : " guardada");
        response.messageSeverity = "success";
        return response;
      }

      if (response.data.code === "err-persona-juridica-already-exist") {
        response.ok = false;
        response.messageText = `Ya se ha registrado ${unUna} ${nameItemText} con ese cuit`;
        response.messageSeverity = "error";
        return response;
      }

      if (response.data.code === "err-persona-juridica-numero-cuit-cuil-invalid") {
        response.ok = false;
        response.messageText = "El número de CUIT ingresado no es válido";
        response.messageSeverity = "error";
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;

  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getPersonaJuridica = async (params) => {
  let _errorMessage = `Se produjo un error al obtener ${nameItemsText}`;

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epName}`,
      params: params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
